export function formatarData(data) {
    if (!data) return '-';

    let isoDate = data;
    if (typeof data === 'string') {
        const partes = data.split(/[-/]/);
        if (partes.length === 3) {
            isoDate =
                partes[0].length === 4
                    ? `${partes[0]}-${partes[1]}-${partes[2]}`
                    : `${partes[2]}-${partes[1]}-${partes[0]}`;
        }
    }

    const dataObj = new Date(isoDate);
    if (isNaN(dataObj.getTime())) return '-';

    return dataObj.toLocaleDateString('pt-BR');
}

export function serializeName(name) {
    if (!name) return '';
    const serialized = name.replace(/\s+/g, '-').toLowerCase();
    return serialized.charAt(0).toUpperCase() + serialized.slice(1);
}
